import React from 'react';
import {Path, useFormContext} from 'react-hook-form';
import {FIELD_TYPES} from '../utils/guestForm';
import {SelectOption} from '../types';

const checkSelectType = (type: FIELD_TYPES) => type === FIELD_TYPES.select;

type UseResetFieldIfTypeChangedProps<T> = {
  fieldName: T;
  type: FIELD_TYPES;
  active?: boolean;
};
function useResetFieldIfTypeChanged<T extends Record<string, string | SelectOption>>({
  fieldName,
  type,
}: UseResetFieldIfTypeChangedProps<Path<T>>) {
  const {getValues, resetField} = useFormContext<T>();
  const isSelectType = checkSelectType(type);

  React.useEffect(
    function resetFieldIfValueIsNotCompatibleToType() {
      const currentValue = getValues()[fieldName];

      const isValueStringAndFieldSelectType = Boolean(
        typeof currentValue === 'string' && isSelectType,
      );

      const isValueOptionAndFieldTextType = Boolean(
        currentValue &&
          typeof currentValue === 'object' &&
          'value' in currentValue &&
          !isSelectType,
      );

      if (isValueStringAndFieldSelectType || isValueOptionAndFieldTextType) {
        resetField(fieldName);
      }
    },
    [resetField, isSelectType, getValues, fieldName],
  );
}

export {useResetFieldIfTypeChanged};
